export class User{

    constructor(
      public username: string,
      public duration: any,
      public usernameqr: string
    ) {  }
  
  }
  